//--------------------------
// is campaign note changed
//--------------------------
export default function isCampaignNoteChanged(original, now) {
  console.log('----------------------------')
  console.log('IN isCampaignNoteChanged')

  console.log('ORIGINAL CAMPAIGN NOTE: ', original)
  console.log('NOW CAMPAIGN NOTE: ', now)

  if (original.note != now.note) {
    console.log('VALUE CHANGED ', original.note)
    return true
  } else {
    console.log('VALUE NOT CHANGED ', original.note)
    return false
  }
}
